export const financeOptionsItems = [
 {
  parentHeader: "invoice financing (account receivables financing)",
  parentSubheader: "Invoice financing is a financing process where a company/customer uses an invoice or invoices as collateral to get a loan from Earnipay.",
  childHeader: "Invoice Financing (Account Receivables Financing)",
  itemDefinition: "Invoice financing is a financing process where a company/customer uses an invoice or invoices as collateral to get a loan from Earnipay.",
  itemDefinition2: "In its simplest form, invoice financing would be based on a single invoice or account receivable with the invoice as collateral. Earnipay operates as the lender advances cash to the business that owns the invoice. Earnipay finances up to 80% of invoices not older than 90 days for an agreed processing fee.",
  interestFeeItems: [
   "0.10% per day or 3% per 30 days",
   "0.10% is applied daily on the total advance payment (80% of invoice amount disbursed)",
   "0.02% extra cost is applied as default for 10 working days. Afterwards, Earnipay may demand repayment of advance payment with accrued but unpaid interest."
  ],
  requirements: [
   "Invoice(s)/Account receievables aging report",
   "6 months' bank statement",
   "Most recent audited financial statement/management account",
   "Letter of introduction of Earnipay as the financing company",
   "Security Cheque (Undated Cheque)",
   "Executed contract agreement",
   "Board resolution accepting the facility"
  ],
  turnAroundTime: "Five (5) working days from the date of receipt of requirements",
 },

 {
  parentHeader: "purchase order financing (account payable / trade credit financing)",
  parentSubheader: "Payables finance or accounts payable financing is a financing solution that allows businesses to access the funds they need to pay their bills.",
  itemDefinition: "Payables finance or accounts payable financing is a financing solution that allows businesses to access the funds they need to pay their bills. With payables finance, Earnipay provides short-term financing to a business, based on the value of its outstanding invoices. Earnipay pays the supplier on behalf of the business, and the business repays Earnipay at a later date.",
  childHeader: "Invoice Financing (Account Receivables Financing)",
  interestFeeItems: ["0.10% per day on the facility amount"],
  requirements: [
   "Proforms Invoice",
   "A valid Local purchase order",
   "List of past contracts completed",
   "Most recent audited financial statement/management account",
   "Irrevocable standing Payment Order",
   "6 months' bank statement",
   "Board resolution accepting the facility"
  ],
  turnAroundTime: "Five (5) working days from the date of receipt of requirements",
 },

 {
  parentHeader: "payroll financing",
  parentSubheader: "Payroll financing enables a company to unlock financing from Earnipay to meet the salary payments schedule and ensure enmployees get paid on time.",
  itemDefinition: "Payroll financing enables a company to unlock financing from Earnipay to meet the salary payments schedule and ensure enmployees get paid on time. Earnipay offers payroll financing only to its On-demand Pay or Payroll Customers. Earnipay provides financing for up to 100% of a company's monthly payroll for a maximum of 30 days for an agreed processing fee.",
  childHeader: "Payroll Financing",
  interestFeeItems: ["3% flat interest rate per month"],
  requirements: [
   "Account receivable age schedules",
   "6 months' bank statement",
   "Most recent audited financial statement/management account",
   "Irrevocable standing Payment Order",
   "Executed contract agreement",
   "Board resolution accepting the facility"
  ],
  turnAroundTime: "Five (5) working days from the date of receipt of requirements",
 },

 {
  parentHeader: "employee loans",
  parentSubheader: "Employee loan is a financing solution that allows employees of companies (who have signed up for an on-demand-pay product of Earnipay) to access funds for family and personal needs.",
  itemDefinition: "Employee loan is a financing solution that allows employees of companies (who have signed up for an on-demand-pay product of Earnipay) to access funds for family and personal needs.",
  childHeader: "employee loans",
  interestFeeItems: ["3% flat interest rate per month"],
  applicationSteps: [
   "First, the company signs up for SLA/MOU with Earnipay limited",
   "Employees fill out the individual Loan Application form and submit it through HR"
  ],
  limits: [
   "Maximum limit - 50% of employee's annual net salary. This is subject to Business's approval."
  ],
  requirements: [
   "Confirmation of Employment letter",
   "Valid ID Card (any National ID plus staff ID Card)",
   "A passport photo",
   "Executed direct debit mandate",
   "Completed and signed loan application form",
  ],
  turnAroundTime: "Five (5) working days from the date of receipt of requirements",
 },
]